module.exports = __webpack_public_path__ + "static/media/save.5c675df6.svg";